import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Modal, Select, Space, Table } from "antd";
import { CloseOutlined, UndoOutlined } from "@ant-design/icons";
import Styles from "./Styles";
import SearchArea from "../../components/moleculas/SearchArea";
import RegistForm from "../../components/moleculas/RegistForm";
import PopServiceSetting from "./PopServiceSetting";
import {
  apiDeleteUsers,
  apiGetServiceAll,
  apiGetSitesComp,
  apiGetUsers,
  apiGetUsersPrev,
  apiGetUserSvc,
  apiPostUsers,
  apiPostUserSvc,
} from "../../api/api";
import "./ManageServiceUser.css";
import Moment from "react-moment";
import { autoTelHyphenConvert, getSessionParam, isEmpty, setSessionParam, sortData } from "../../utils/comm";

const { Option } = Select;
const { Search } = Input;
const { Column } = Table;

let useYn = null;
let mmsYn = null;
let bfUserId = null;

function ManageServiceUser() {
  const telRegExp = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
  const phoneRegExp = /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))-(\d{4})$/;

  // Parameter Save
  const [defaultValue] = useState({
    siteId: getSessionParam("siteId"),
    siteNm: getSessionParam("siteNm"),
  });

  // Start of View Data
  // 검색 데이터
  const [searchForm, setSearchForm] = useState({
    userId: "",
    compId: "",
    siteId: defaultValue.siteId,
    siteNm: defaultValue.siteNm,
    searchKeyword: null,
    sort: "",
  });
  const [isModalServiceSet, setIsModalServiceSet] = useState(false); // 모달 표시 상태
  const [isEditEmail, setEditEmail] = useState(true); // 모달 표시 상태
  const [modalData, setModalData] = useState([]); // 모달에서 사용할 데이터
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [data, setData] = useState([]); // 사용자 목록 데이터
  const [form] = Form.useForm(); // 사용자 저장(추가/수정) form 데이터
  // End of View Data

  // Start of DATA
  // 사업장 목록
  const [siteList, setSiteList] = useState(
    !isEmpty(searchForm.siteId) && !isEmpty(searchForm.siteNm)
      ? [
          {
            siteId: searchForm.siteId,
            siteNm: searchForm.siteNm,
          },
        ]
      : []
  );
  const [authList, setAuthList] = useState([]);
  // End of DATA

  // Start of 초기화
  useEffect(() => {
    initData().then();
  }, []);

  // 데이터 초기화
  const initData = async () => {
    // 권한 목록 데이터 조회
    await getAuthList();
    // 사업장 목록 데이터
    await getSiteCompList();

    await getUserList();
  };
  // End of 초기화

  // Start of API Function
  // 권한 목록 조회
  const getAuthList = async () => {
    try {
      const response = await apiGetUsersPrev();
      if (response.code === 0) {
        setAuthList(response.data);
      } else {
        setAuthList([]);
      }
    } catch (e) {}
  };

  // 사업장 목록 조회
  const getSiteCompList = async () => {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };
    try {
      const response = await apiGetSitesComp(model);
      if (response.data.code === 0) {
        setSiteList(response.data.data);
      } else {
        setSiteList([]);
      }
    } catch (e) {}
  };

  // 사용자 목록 조회
  const getUserList = async () => {
    try {
      const model = { ...searchForm };
      const response = await apiGetUsers(model);

      if (response && response.code === 0 && response.data && response.data.length > 0) {
        const resData = response.data;

        let dataNum = 0;
        const inputData = new Array(resData.length).fill(null).map((value, index, array) => ({
          key: index,
          userId: resData[index].userId,
          siteId: resData[index].siteId,
          siteNm: resData[index].siteNm,
          compId: resData[index].compId,
          authCd: resData[index].authCd,
          userNm: resData[index].userNm,
          dept: resData[index].dept,
          email: resData[index].email,
          tel1: resData[index].tel1,
          createDt: resData[index].createDt,
          use: resData[index].useYn === "Y",
          mms: resData[index].mmsYn === "Y",
          edit: false,
        }));
        setData(inputData);
      } else {
        setData([]);
      }
    } catch (e) {}
  };
  // End of API Function

  // Start of View Function
  // 사업장 선택
  const onChangeSiteId = async (value, option) => {
    await setSearchForm((prevSearchForm) => {
      let searchForm = { ...prevSearchForm };
      searchForm.siteId = option ? value : null;
      searchForm.siteNm = option ? option.children : null;
      return searchForm;
    });

    setSessionParam({
      siteId: option ? value : null,
      siteNm: option ? option.children : null,
    });

    getUserList().then();
  };

  // 검색어 변경
  const onChangeSearchKeyword = async (e) => {
    await setSearchForm((prevSearchForm) => {
      let searchForm = { ...prevSearchForm };
      searchForm.searchKeyword = e.target.value;
      return searchForm;
    });
  };

  // 검색
  const onSearch = (resetFlag) => {
    if (resetFlag) searchForm.searchKeyword = "";

    getUserList().then();
  };

  // 사용여부 변경
  const onChangeUse = async (record, e) => {
    data.find((value) => value.userId === record.userId).use = e.target.checked;
    useYn = record.use;

    const model = {
      siteId: record.siteId,
      userId: record.userId,
      authCd: record.authCd,
      userNm: record.userNm,
      dept: record.dept,
      email: record.email,
      tel1: record.tel1,
      use: useYn,
      mms: record.mms,
    };

    await apiPostUsers(model);
  };

  const onChangeMMS = async (record, e) => {
    if (!record.tel1) {
      Modal.confirm({
        title: "MMS 수신",
        icon: null,
        content: "MMS 수신을 원할 경우 연락처(휴대전화) 정보를 입력하세요.",
        okText: "확인",
        cancelButtonProps: { style: { display: "none" } },
        onOk: () => {},
      });
    } else {
      data.find((value) => value.userId === record.userId).mms = e.target.checked;
      mmsYn = record.mms;

      const model = {
        siteId: record.siteId,
        userId: record.userId,
        authCd: record.authCd,
        userNm: record.userNm,
        dept: record.dept,
        email: record.email,
        tel1: record.tel1,
        use: record.use,
        mms: mmsYn,
      };

      await apiPostUsers(model);
    }
  };

  // 연락처 포맷
  const validateTelNumber = (validate, value) => {
    if (!isEmpty(value) && !telRegExp.test(value) && !phoneRegExp.test(value)) {
      return Promise.reject(new Error(validate.message));
    } else {
      return Promise.resolve();
    }
  };

  // 전화변호 입력 값이 변경될 때마다 하이픈을 자동으로 입력한다.
  const autoTelHyphenInput = (e) => {
    let telValue = e.target.value;
    const fields = form.getFieldsValue();
    form.setFieldsValue({
      ...fields,
      tel1: autoTelHyphenConvert(telValue),
    });
  };

  // 리셋 버튼 동작
  const resetRegistForm = () => {
    form.resetFields();
    setEditEmail(true);
    setData([]);

    getUserList().then();
  };

  // 사용자 관리 서비스 설정 모달 호출
  const showSetSetUserServiceModal = async (record) => {
    const serviceAllList = await apiGetServiceAll(record);
    const userSvcList = await apiGetUserSvc(record);

    let mModalData = [
      {
        title: "전체",
        key: "ALL",
        children: [],
      },
    ];

    const userId = record.userId;
    const siteId = record.siteId;

    if (serviceAllList && serviceAllList.data && serviceAllList.data.length > 0) {
      serviceAllList.data.forEach((v) => {
        v.userId = userId;
        v.siteId = siteId;
        let mModalChildData = { key: v.catCd, title: v.catNm, record: v };
        mModalData[0].children.push(mModalChildData);
      });
    }

    let mCheckedKeys = [];
    if (userSvcList && userSvcList.data && userSvcList.data.length > 0) {
      userSvcList.data.forEach((v) => {
        mCheckedKeys.push(v.funCd);
      });
    }

    setModalData(mModalData);
    setCheckedKeys(mCheckedKeys);

    setIsModalServiceSet(true); // 모달 표시
  };

  // 사용자 관리 서비스 설정 체크박스
  const onCheck = async (checked, e) => {
    setCheckedKeys(checked);
  };
  // 사용자 관리 서비스 설정 저장
  const saveUserSvc = async (a, b, c, d) => {
    let mCheckedKeys = checkedKeys.filter((el) => el !== "ALL");
    let model = [];
    modalData[0].children.forEach((v) => {
      let svc = {
        funCd: v.record.catCd,
        siteId: v.record.siteId,
        userId: v.record.userId,
        useYn: mCheckedKeys.includes(v.record.catCd) ? "Y" : "N",
      };
      model.push(svc);
    });

    await apiPostUserSvc(model);

    setIsModalServiceSet(false); // 모달 숨김
  };

  // 사용자 삭제 함수
  const deleteUser = async (index) => {
    const record = data[index];
    const model = {
      userId: record.userId,
    };

    await apiDeleteUsers(model);
    await resetRegistForm();
  };

  // 삭제 버튼 클릭시 삭제 확인 창 호출
  const confirmDeleteUser = async (index) => {
    Modal.confirm({
      title: "사용자 삭제",
      icon: null,
      content: "삭제하시겠습니까?",
      okText: "예",
      cancelText: "아니오",
      centered: true,
      onOk: () => deleteUser(index),
    });
  };

  // 로우 클릭 시 사용자 저장 (수정/삭제) form 에 데이터 기입
  const userRowClick = async (data, index) => {
    let jsonObj = JSON.parse(JSON.stringify(data));

    if (bfUserId != null && bfUserId !== jsonObj.userId) {
      useYn = null;
    }
    bfUserId = jsonObj.userId;

    form.setFieldsValue(data);
    setEditEmail(false);
  };

  // 사용자 추가(저장)
  const onSubmit = async (fields) => {
    let jsonObj = JSON.parse(JSON.stringify(fields));
    let strTitle;
    let strContent;

    if (isEmpty(jsonObj.userId)) {
      strTitle = "임시 패스워드 발송";
      strContent = "해당 담당자 메일주소로 임시 패스워드가 발송 되었습니다.";
    } else {
      strTitle = "저장 완료";
      strContent = "저장이 완료되었습니다.";
    }
    const res = await apiPostUsers(fields);
    
    if (res.data != null && res.code != null && (res.code === 0 || res.code === 2)) {
      Modal.info({
        title: strTitle,
        icon: null,
        content: strContent,
        okText: "확인",
        centered: true,
        onOk() {
          resetRegistForm();
        },
      });
    } else if (res.data != null && res.code != null && res.code === 23) {
      Modal.info({
        title: "오류 발생",
        icon: null,
        content: "이미 등록된 이메일 입니다.",
        okText: "확인",
        centered: true,
        onOk() {
          resetRegistForm();
        },
      });
    } else {
      Modal.info({
        title: "오류 발생",
        icon: null,
        content: "오류가 발생되었습니다.",
        okText: "확인",
        centered: true,
        onOk() {
          resetRegistForm();
        },
      });
    }
  };

  // End of View Function

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>서비스 사용자 관리</h1>
      {/*<ServiceInfo />*/}
      <SearchArea
        leftExtra={
          <Space size={[12, "small"]}>
            <div className='condition-item'>
              <label htmlFor='s11'>사업장</label>
              <Select
                style={{ minWidth: 148 }}
                id='s11'
                placeholder='선택'
                value={searchForm.siteId}
                // defaultValue={defaultValue.siteId}
                onChange={(value, option) => onChangeSiteId(value, option)}
              >
                <Option value=''>전체</Option>
                {siteList.map((item, index) => (
                  <Option key={index} value={item.siteId}>
                    {item.siteNm}
                  </Option>
                ))}
                {/*<Option value="a1">구로터미널</Option>*/}
                {/*<Option value="a2">영등포터미널</Option>*/}
                {/*<Option value="a3">동대문터미널</Option>*/}
              </Select>
            </div>
          </Space>
        }
        rightExtra={
          <Space className={"rpc-head-container"}>
            <Search
              className={"rpc-head-item"}
              placeholder='검색'
              // defaultValue={defaultValue.searchKeyword}
              value={searchForm.searchKeyword}
              onChange={onChangeSearchKeyword}
              onSearch={() => onSearch(false)}
            />
            <Button className='btn-gray rpc-head-button' onClick={() => onSearch(true)}>
              초기화
            </Button>
          </Space>
        }
      />
      <RegistForm
        onSubmit={onSubmit}
        form={form}
        items={
          <>
            <div className='condition-item'>
              <label htmlFor='s1'>사업장</label>
              <Form.Item name={"userId"} noStyle={true}>
                <Input type={"hidden"} />
              </Form.Item>
              <Form.Item name={"use"} noStyle={true}>
                <Input type={"hidden"} />
              </Form.Item>
              <Form.Item name={"mms"} noStyle={true}>
                <Input type={"hidden"} />
              </Form.Item>
              <Form.Item
                hasFeedback={false}
                name={"siteId"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  style={{ width: 148 }}
                  id='s1'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  placeholder='선택'
                >
                  {siteList.map((item, index) => (
                    <Option key={index} value={item.siteId}>
                      {item.siteNm}
                    </Option>
                  ))}
                  {/*<Option value="a1">구로터미널</Option>*/}
                  {/*<Option value="a2">영등포터미널</Option>*/}
                  {/*<Option value="a3">동대문터미널</Option>*/}
                </Select>
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s2'>담당</label>
              <Form.Item
                hasFeedback={false}
                name={"authCd"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  style={{ width: 148 }}
                  id='s2'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  placeholder='선택'
                >
                  {authList.map((item, index) => (
                    <Option key={index} value={item.code}>
                      {item.codeNm}
                    </Option>
                  ))}
                  {/*<Option value="a1">홍길동1</Option>*/}
                  {/*<Option value="a2">홍길동2</Option>*/}
                  {/*<Option value="a3">홍길동3</Option>*/}
                </Select>
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s3'>이름</label>
              <Form.Item
                name={"userNm"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 148 }} id='s3' maxLength={60} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s4'>부서</label>
              <Form.Item
                name={"dept"}
                rules={[
                  {
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 148 }} id='s4' maxLength={100} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s5'>이메일</label>
              <Form.Item
                name={"email"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 148 }} id='s5' maxLength={100} readOnly={!isEditEmail} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s6'>연락처</label>
              <Form.Item
                name={"tel1"}
                rules={[
                  {
                    validator: validateTelNumber,
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 148 }} id='s6' maxLength={13} onChange={autoTelHyphenInput} />
              </Form.Item>
              {/* testing */}
              <Form.Item name={"mmsYn"} hidden={true}>
                <Input id='s7' maxLength={2} hidden={true} disabled={true} />
              </Form.Item>
            </div>
          </>
        }
        buttons={[
          <Button type='primary' key={"b1"} htmlType='submit'>
            저장
          </Button>,
          <Button size='small' key={"b2"} icon={<UndoOutlined />} onClick={resetRegistForm} />,
        ]}
      />

      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table
          dataSource={data}
          bordered
          pagination={false}
          showSorterTooltip={false}
          scroll={{ x: 1300 }}
          onRow={(data, index) => {
            return {
              onClick: () => userRowClick(data, index),
            };
          }}
        >
          <Column title='No' key='1' width='4%' render={(value, record, index) => index + 1} />
          <Column
            title='담당'
            dataIndex='authCd'
            key='2'
            width='13%'
            sorter={(a, b) => sortData(a.authCd, b.authCd)}
            render={(value) => {
              const auth = authList.find((v) => v.code === value);
              // const auth = authList.find(v => v.code === value.replace('ROL', 'AUC'));
              if (auth) {
                return auth.codeNm;
              } else {
                return value;
              }
            }}
          />
          <Column
            title='이름'
            dataIndex='userNm'
            key='3'
            width='13%'
            sorter={(a, b) => sortData(a.userNm, b.userNm)}
            render={(value, record, index) => (
              <Button
                className='btn-link'
                onClick={(e) => {
                  e.stopPropagation(); // row 클릭 이벤트 방지
                  showSetSetUserServiceModal(record).then(); // 사용자 서비스 설정 모달 호출
                }}
              >
                {value}
              </Button>
            )}
          />
          <Column title='부서' dataIndex='dept' key='4' sorter={(a, b) => sortData(a.dept, b.dept)} />
          <Column title='이메일' dataIndex='email' key='5' width='13%' sorter={(a, b) => sortData(a.email, b.email)} />
          <Column
            title='연락처(휴대전화)'
            dataIndex='tel1'
            key='6'
            width='13%'
            sorter={(a, b) => sortData(a.tel1, b.tel1)}
          />
          <Column
            title='추가일'
            dataIndex='createDt'
            key='7'
            width='13%'
            sorter={(a, b) => sortData(a.createDt, b.createDt)}
            render={(value) => <Moment date={value} format={"YYYY-MM-DD"} />}
          />
          <Column
            title='사용여부'
            dataIndex='use'
            key='8'
            width='6%'
            // sorter={(a, b) => sortData(a.use, b.use)}
            render={(value, record) => (
              <Checkbox
                defaultChecked={value}
                onChange={(e) => {
                  e.stopPropagation(); // row 클릭 이벤트 방지
                  onChangeUse(record, e).then();
                }}
                onClick={(e) => e.stopPropagation()}
              />
            )}
          />
          <Column
            title={"MMS 수신"}
            dataIndex={"mms"}
            render={(value, record) => (
              <Checkbox
                defaultChecked={value}
                onChange={(e) => {
                  e.stopPropagation(); // row 클릭 이벤트 방지
                  onChangeMMS(record, e).then();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!record.tel1) {
                    e.target.checked = false;
                  }
                }}
              />
            )}
          />
          <Column
            title='삭제'
            dataIndex='delete'
            key='9'
            width='6%'
            render={(value, record, index) => {
              const isOwn = record.userId === sessionStorage.getItem("userId");
              return (
                <Button
                  icon={<CloseOutlined />}
                  size='small'
                  className='btn-ico-del'
                  disabled={isOwn}
                  onClick={(e) => {
                    e.stopPropagation(); // row 클릭 이벤트 방지
                    confirmDeleteUser(record.key).then();
                  }}
                />
              );
            }}
          />
        </Table>
      </div>

      <Modal
        title='사용자 관리 서비스 설정'
        visible={isModalServiceSet}
        onCancel={() => setIsModalServiceSet(false)}
        width={422}
        centered
        okText='저장'
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={saveUserSvc}
      >
        <PopServiceSetting treeData={modalData} checkedKeys={checkedKeys} onCheck={onCheck} />
      </Modal>
    </Styles>
  );
}

export default ManageServiceUser;
